import { MouseEventHandler } from 'react'

import classNames from 'classnames'

import Clickable from '@web/components/Clickable'
import ModalContainer from '@web/components/Modal/ModalContainer'
import { ModalComponent } from '@web/components/Modal/types'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { useNavigation } from '@web/hooks/useNavigation'
import nClicks from '@web/libs/nlog/click/codes'

import styles from './index.module.scss'

const ProfileResetModal: ModalComponent = ({ showModal, confirmModal }) => {
  const { isFromMapsApp } = useGlobalStaticStateContext()
  const navigation = useNavigation()
  const nClicksArea = isFromMapsApp ? nClicks.gnbmap : nClicks.gnb

  return (
    <ModalContainer showModal={showModal} className={styles.modal_guide}>
      <div className={styles.inner}>
        <div className={styles.txt_area}>
          <p className={styles.paragraph}>
            프로필 이용방법에 맞지 않는 정보가 확인되어 프로필 정보가 초기화되었습니다.
          </p>
          <p className={styles.paragraph}>프로필 이용 방법에 맞는 프로필로 재설정해주세요.</p>
        </div>
      </div>
      <div className={styles.btn_area}>
        <Clickable
          className={classNames(styles.btn, styles.type_confirm)}
          onClick={confirmModal as MouseEventHandler}
          nClickCode={nClicksArea.PROFILERESET}
        >
          확인
        </Clickable>
        <Clickable
          className={styles.btn}
          nClickCode={nClicksArea.PROFILERESETGUIDE}
          onClick={() => {
            confirmModal()
            navigation.push({ url: 'https://m.blog.naver.com/nv_placemy/222752513954' })
          }}
        >
          가이드 보기
        </Clickable>
      </div>
    </ModalContainer>
  )
}

export default ProfileResetModal
